import { ordermanagerUrl } from "../resources";
import common from '../commons/getRequest'

async function getOrderManagerState(restaurantId) {
    let data = null;
    let url = `${ordermanagerUrl}/GetOrderManagerStateByRestaurant/${restaurantId}`;

    await common.getData(url)
                .then(res => data = res);
    console.log(data)
    return data;
}

async function getCurrentWaitingTime(restaurantId) {
    let data = null;
    let url = `${ordermanagerUrl}/GetCurrentWaitingTimeByRestaurant/${restaurantId}`;
    await common.getData(url)
                .then(response => data = response);
    return data;
}

export default {
    getCurrentWaitingTime,
    getOrderManagerState
}